import React from "react";
import {
  Grid,
  Typography,
  Alert,
  Box,
  TextField,
  Button,
  Switch,
  FormControlLabel,
} from "@mui/material";

const VisibilityTab = ({ t, DAYS, values, setFieldValue }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mb: 2 }}
        >
          <Alert severity="info">
            {t("pages.dsokPromotions.visibilityHelpText")}
          </Alert>
        </Typography>
        <Box
          sx={{
            border: 1,
            borderColor: "divider",
            borderRadius: 1,
            p: 1.5,
            mb: 1,
          }}
        >
          {DAYS.map((day) => {
            const dayData = values.visibility?.[day] || {
              enabled: false,
              intervals: [],
            };
            const dayLabel = t(`days.${day}`) || day;
            return (
              <Box
                key={day}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  mb: 1.5,
                  p: 1,
                  borderRadius: 1,
                  bgcolor: dayData.enabled ? "action.hover" : "inherit",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography variant="body2">{dayLabel}</Typography>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={Boolean(dayData.enabled)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setFieldValue(`visibility.${day}.enabled`, checked);
                          if (checked && !Array.isArray(dayData.intervals)) {
                            setFieldValue(`visibility.${day}.intervals`, []);
                          }
                        }}
                        name={`visibility.${day}.enabled`}
                        color="primary"
                      />
                    }
                    label={t("common.active", { defaultValue: "Active" })}
                    sx={{ m: 0 }}
                  />
                </Box>
                {dayData.enabled && (
                  <Box sx={{ pl: 0.5 }}>
                    {(dayData.intervals || []).map((interval, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1,
                        }}
                      >
                        <TextField
                          size="small"
                          type="time"
                          label={t("pages.dsokCategories.timeFrom")}
                          value={interval?.from || ""}
                          onChange={(e) =>
                            setFieldValue(
                              `visibility.${day}.intervals.${idx}.from`,
                              e.target.value
                            )
                          }
                          InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                          size="small"
                          type="time"
                          label={t("pages.dsokCategories.timeTo")}
                          value={interval?.to || ""}
                          onChange={(e) =>
                            setFieldValue(
                              `visibility.${day}.intervals.${idx}.to`,
                              e.target.value
                            )
                          }
                          InputLabelProps={{ shrink: true }}
                        />
                        <Button
                          color="error"
                          size="small"
                          variant="outlined"
                          onClick={() => {
                            const next = (dayData.intervals || []).filter(
                              (_, i) => i !== idx
                            );
                            setFieldValue(`visibility.${day}.intervals`, next);
                          }}
                        >
                          {t("buttons.delete")}
                        </Button>
                      </Box>
                    ))}
                    {(!dayData.intervals || dayData.intervals.length === 0) && (
                      <Typography variant="caption" color="text.secondary">
                        {t("pages.dsokCategories.noIntervals", {
                          defaultValue: "No intervals added",
                        })}
                      </Typography>
                    )}
                    <Box sx={{ mt: 1 }}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => {
                          const next = Array.isArray(dayData.intervals)
                            ? [...dayData.intervals]
                            : [];
                          next.push({ from: "08:00", to: "17:00" });
                          setFieldValue(`visibility.${day}.intervals`, next);
                        }}
                      >
                        {t("pages.dsokCategories.addInterval", {
                          defaultValue: "Add interval",
                        })}
                      </Button>
                    </Box>
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      </Grid>
    </Grid>
  );
};

export default VisibilityTab;
